import {date} from "quasar";

export function intersection(a, b) {
    if(a === undefined || b === undefined) return [];
    if(a === null || b === null) return [];
    return a.filter(x => b.includes(x));
}

export function epoch_offset_to_datetime(patient, offset, use_now) {
      let epoch_datetime = new Date(patient.epoch_datetime)
      //let epoch_datetime = date.extractDate(patient.epoch_datetime, 'YYYY-MM-DD[T]HH:mm:ss.SSS');
      if(patient.patient_type==='template' && use_now===true){
         epoch_datetime = new Date()
      }
      return date.addToDate(epoch_datetime, {minutes: offset})
    }
export function datetime_to_epoch_offset(patient, datetime) {
      let epoch_datetime = new Date(patient.epoch_datetime)
      //const epoch_datetime = date.extractDate(patient.epoch_datetime, 'YYYY-MM-DD[T]HH:mm:ss.SSS');
      return date.getDateDiff(datetime, epoch_datetime, 'minutes')
    }
export function datetimedmy_to_epoch_offset(patient, datetime) {
      let epoch_datetime = new Date(patient.epoch_datetime)
      //const epoch_datetime = date.extractDate(patient.epoch_datetime, 'YYYY-MM-DD[T]HH:mm:ss.SSS');
      const datetime_obj = date.extractDate(datetime, 'D MMM YYYY HH:mm');
      return date.getDateDiff(datetime_obj, epoch_datetime, 'minutes')
    }

export function render_offset(offset) {
    let marker = "before start"
    if(offset > 0){
        marker = "after start"
    }
    const o = Math.abs(offset);
    let years = o/(60 * 24 * 365);
    if(years >= 1 && o%(60 * 24 * 365)===0) return `${years} years ${marker}`;
    let months = o/(60 * 24 * 30);
    if(months >= 1 && o%(60 * 24 * 30)===0) return `${months} months ${marker}`;
    let days = o/(60 * 24);
    if(days >= 1 && o%(60 * 24)===0) return `${days} days ${marker}`;
    let hours = o/60;
    if(hours >= 1 && o%60===0) return `${hours} hours ${marker}`;
    return `${o} minutes ${marker}`;

}

export function date_string(patient, offset, use_now) {
      if(offset === undefined || offset === null) {
        return '';
      }
      if(use_now!==true && ["template", "scene"].includes(patient.patient_type)){
          return render_offset(offset);
      }
      return date.formatDate(epoch_offset_to_datetime(patient, offset, use_now), 'DD MMM YYYY')
    }
// The calendar date a date_of_birth offset is shown as. An age entered as N
// years is stored as exactly N x 365 days (and Patient.age reads it back as N
// Years), but N x 365 days before the epoch lands after the real birthday
// because of leap days (issue 1237). So a negative offset that is a whole
// number of 365-day years is drawn as the date exactly N years before the
// epoch date (29 Feb -> 28 Feb); any other offset is epoch + offset as before.
// Templates and scenes still render as "N years before start", as date_string.
export function dob_datetime(patient, offset, use_now) {
      const year_minutes = 60 * 24 * 365;
      if(offset < 0 && offset % year_minutes === 0){
          const epoch = epoch_offset_to_datetime(patient, 0, use_now)
          return date.subtractFromDate(epoch, {years: -offset / year_minutes})
      }
      return epoch_offset_to_datetime(patient, offset, use_now)
    }
export function dob_string(patient, offset, use_now) {
      if(offset === undefined || offset === null) {
        return '';
      }
      if(use_now!==true && ["template", "scene"].includes(patient.patient_type)){
          return render_offset(offset);
      }
      return date.formatDate(dob_datetime(patient, offset, use_now), 'DD MMM YYYY')
    }
// The age a patient shows at a given moment (issue 582): exactly the backend's
// Patient.age (date_of_birth is minutes before the start; under 30 days is
// "0 Months", under 365 days is days // 30 "Months", else days // 365 "Years"),
// plus the time the patient's own clock has run since its start. `at` is the
// patient's current time (patientStore.patient_time, or the simulation clock).
// Only a patient with its own epoch (an instance copy) has a clock: for a
// template or scene, or with no `at`, this is the age at start, which equals
// patient.age. Elapsed time is whole minutes, rounded (the epoch keeps seconds,
// patient_clock_offset does not) and never negative (a backward warp stops at
// the start). No DOB, or a garbage one, falls back to patient.age.
export function patient_age(patient, at) {
      const dob = patient.date_of_birth
      if(dob === undefined || dob === null) return patient.age
      let minutes = -Number(dob)
      if(at && !["template", "scene"].includes(patient.patient_type) && patient.epoch_datetime) {
          const elapsed = Math.round((new Date(at) - new Date(patient.epoch_datetime)) / 60000)
          if(Number.isFinite(elapsed)) minutes += Math.max(elapsed, 0)
      }
      if(!Number.isFinite(minutes) || Math.abs(minutes) > 1e12) return patient.age
      const days = Math.floor(minutes / (60 * 24))
      if(days < 30) return "0 Months"
      if(days < 365) return `${Math.floor(days / 30)} Months`
      return `${Math.floor(days / 365)} Years`
    }
// The DOB a student's activity card shows for an activity patient. Its
// date_of_birth is an offset from an epoch: once the student has opened the
// patient, the copy's chart measures it from the copy's epoch
// (instance_epoch_datetime, from get_student_activity), so the card does too.
// Before that there is no copy, and it is measured from now, as the copy will
// be. Never from the activity's embedded epoch, which is whenever the template
// was last saved (issue 547: 29 Dec 1959 on the card, 1962 on the chart).
export function card_date_of_birth(patient) {
      if (patient.instance_epoch_datetime) {
        return dob_string({ ...patient, patient_type: 'individual', epoch_datetime: patient.instance_epoch_datetime }, patient.date_of_birth)
      }
      return dob_string({ ...patient, patient_type: 'template' }, patient.date_of_birth, true)
    }
// patient_age for the activity card. Its clock is the copy's epoch
// (instance_epoch_datetime); before the copy exists there is no clock, so it is
// the age at start.
export function card_age(patient, at) {
      if (patient.instance_epoch_datetime) {
        return patient_age({ ...patient, patient_type: 'individual', epoch_datetime: patient.instance_epoch_datetime }, at)
      }
      return patient_age(patient)
    }
export function time_string(patient, offset) {
      if(offset === undefined || offset === null) {
        return '';
      }
      return date.formatDate(epoch_offset_to_datetime(patient, offset), 'HH:mm')
    }
export function date_time_string(patient, offset) {
      if(offset === undefined || offset === null) {
        return '';
      }
      if(["template", "scene"].includes(patient.patient_type)){
          return (render_offset(offset));
      }
      return date.formatDate(epoch_offset_to_datetime(patient, offset), 'DD MMM YYYY HH:mm')
    }

export function calc_fields(value){
      let time_number = null;
      let timeframe = null;
      if(value === null || value === undefined || value === ''){
        time_number = '';
        timeframe = 'minutes';
        return {time_number, timeframe};
      }
      let years = -value/(60 * 24 * 365);
      if(years >= 1 && value % (60 * 24 * 365) === 0){
        time_number = years;
        timeframe = 'years';
        return {time_number, timeframe};
      }
      let months = -value/(60 * 24 * 30);
      if(months >= 1 && value % (60 * 24 * 30) === 0){
        time_number = months;
        timeframe = 'months';
        return {time_number, timeframe};
      }
      let weeks = -value/(60 * 24 * 7);
      if (weeks >= 1 && value % (60 * 24 * 7) === 0){
        time_number = weeks;
        timeframe = 'weeks';
        return {time_number, timeframe};
      }
      let days = -value/(60 * 24);
      if (days >= 1 && value % (60 * 24) === 0){
        time_number = days;
        timeframe = 'days';
        return {time_number, timeframe};
      }
      let hours = -value/60;
      if (hours >= 1 && value % 60 === 0){
        time_number = hours;
        timeframe = 'hours';
        return {time_number, timeframe};
      }
      time_number = -value;
      timeframe = 'minutes';
      return {time_number, timeframe};
    }

export let frequencies = {
    'Immediately (STAT)': null,
    'Now': null,
    'Continuous': null,
    'Every 5 Minutes': 5,
    'Every 15 Minutes': 15,
    'Every 30 Minutes': 30,
    'Every Hour (QH)': 60,
    'Every 2 Hours (Q2H)': 60 * 2,
    'Every 3 Hours (Q3H)': 60 * 3,
    'Every 4 Hours (Q4H)': 60 * 4,
    'Every 6 Hours (Q6H)': 60 * 6,
    'Every 8 Hours (Q8H)': 60 * 8,
    'Every 12 Hours (Q12H)': 60 * 12,
    'Twice Daily (BID)': 60 * 12,
    'Three Times Daily (TID)': 60 * 8,
    'Four Times Daily (QID)': 60 * 6,
    'Daily': 60 * 24,
    'Every Other Day': 60 * 24 * 2,
    'Once': null,
    'Weekly': 60 * 24 * 7,
    'Monthly': 60 * 24 * 30,
    'Quarterly': 60 * 24 * 30 * 3,
    'Yearly': 60 * 24 * 365,
    'Before Meals (AC)': null,
    'After Meals (PC)': null,
    'At Bedtime (HS)': null,
    'Before Meals and at Bedtime (ACHS)': null,
    'Three Times Daily Before Meals (TID AC)': null
}

/**
 * Convert a measurement to a target unit.
 * Accepts a measurement object with { number, number2, unit } structure.
 * Supports compound units like 'ft,in' and 'lb,oz'.
 * 
 * @param {Object} measurement - The measurement object containing number, number2 (optional), and unit
 * @param {string} to - The target unit to convert to
 * @returns {number|null} The converted value, or null if measurement is null/undefined
 */
export function convert(measurement, to){
    if(!measurement) return null;
    
    const { number, number2, unit } = measurement;
    
    if(unit === to) return parseFloat(number);
    if(unit === null || to === null) return parseFloat(number);
    if(unit === undefined || to === undefined) return parseFloat(number);
    
    // Compound units - combine then convert.
    //
    // 'lbs, oz' is the unit string the FIELDS actually carry (Newborn Weight,
    // and Weight once the newborn units were added to it). The 'lb,oz' and
    // 'ft,in' spellings below match no field in the system — checked across
    // all 4,349 published fields, where 'lbs, oz' is the only compound unit
    // that exists — so they are kept only in case a draft uses them. Without
    // the 'lbs, oz' branch a newborn weight fell through to parseFloat(number)
    // and plotted the POUNDS while silently discarding the ounces.
    if(unit === 'ft,in') {
        const totalInches = (parseFloat(number) * 12) + (parseFloat(number2) || 0);
        if(to === 'cm') return totalInches * 2.54;
        if(to === 'in') return totalInches;
    }
    if(unit === 'lb,oz' || unit === 'lbs, oz') {
        const totalOunces = (parseFloat(number) * 16) + (parseFloat(number2) || 0);
        if(to === 'kg') return totalOunces * 0.0283495;
        if(to === 'lb' || to === 'lbs' || to === 'lbs, oz') return totalOunces / 16;
        if(to === 'oz') return totalOunces;
        if(to === 'grams') return totalOunces * 28.349523125;
    }
    // 'grams' is the other Newborn Weight unit. It had no conversion at all,
    // so a 3500 g newborn plotted as 3500 against a kg axis.
    if(unit === 'grams') {
        const grams = parseFloat(number);
        if(to === 'kg') return grams / 1000;
        if(to === 'lb' || to === 'lbs' || to === 'lbs, oz') return grams / 453.59237;
        if(to === 'oz') return grams / 28.349523125;
    }
    if(to === 'grams') {
        const value = parseFloat(number);
        if(unit === 'kg') return value * 1000;
        if(unit === 'lb' || unit === 'lbs') return value * 453.59237;
        if(unit === 'oz') return value * 28.349523125;
    }

    // Simple unit conversions
    const value = parseFloat(number);
    if(unit==='C' && to==='F') return value * 9/5 + 32;
    if(unit==='F' && to==='C') return (value - 32) * 5/9;
    if(unit==='kg' && to==='lb') return value * 2.20462;
    if(unit==='lb' && to==='kg') return value / 2.20462;
    if(unit==='cm' && to==='in') return value / 2.54;
    if(unit==='in' && to==='cm') return value * 2.54;
    if(unit==='g/DL' && to==='g/L') return value * 10;
    if(unit==='g/L' && to==='g/DL') return value / 10;
    if(unit==='mg/dL' && to==='mmol/L') return value / 18.01528;
    if(unit==='mmol/L' && to==='mg/dL') return value * 18.01528;
    if(unit==='mEq/L' && to==='mmol/L') return value;
    if(unit==='mg/dl' && to==='µmol/L') return value * 88.4;
    if(unit==='µmol/L' && to==='mg/dl') return value / 88.4;
    if(unit==='10³/μL' && to ==='10⁹/L') return value / 1000;
    if(unit==='10⁹/L' && to ==='10³/μL') return value * 1000;
    if(unit==='10⁶/μL' && to ==='10¹²/L') return value / 1000000;
    if(unit==='10¹²/L' && to ==='10⁶/μL') return value * 1000000;
    
    return value;
}

export function sha256(string) {
  const utf8 = new TextEncoder().encode(string);
  return crypto.subtle.digest('SHA-256', utf8).then((hashBuffer) => {
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map((bytes) => bytes.toString(16).padStart(2, '0'))
      .join('');
    return hashHex;
  });
}

export function can_passkey(){
  // Availability of `window.PublicKeyCredential` means WebAuthn is usable.
  // `isUserVerifyingPlatformAuthenticatorAvailable` means the feature detection is usable.
  // `isConditionalMediationAvailable` means the feature detection is usable.
  if (window.PublicKeyCredential) {
    if (window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable) {
      if (window.PublicKeyCredential.isConditionalMediationAvailable) {
        return true;
      }
    }
  }
return false
}


/**
 * Returns the display name for a patient following EHR conventions:
 * "Legal Name (Preferred Name)" when both exist and differ,
 * otherwise whichever is available.
 *
 * @param {Object} patient - Patient object with legal_name, preferred_name, and/or name fields
 * @returns {string}
 */
export function patientDisplayName(patient) {
    if (!patient) return '';
    const legal = patient.legal_name;
    const preferred = patient.preferred_name;
    if (legal && preferred && legal !== preferred) {
        return `${legal} (${preferred})`;
    }
    return legal || preferred || patient.name || '';
}

/**
 * Returns initials for a patient, derived from legal_name only
 * (ignores preferred name to avoid parentheses in initials).
 * Falls back to patient.name if legal_name is not available.
 *
 * The result is at most 2 characters and is built from the first letter of
 * the first two whitespace-separated tokens that begin with a Unicode letter.
 * Tokens that start with digits or punctuation (e.g. "1", "-", "10") are
 * skipped so that test/placeholder names like
 *   "Patient 1 - Test - Test - Test"
 * produce stable two-character initials ("PT") that fit inside the avatar
 * circle, instead of overflowing it (issue #733).
 *
 * @param {Object} patient - Patient object
 * @returns {string}
 */
export function patientInitials(patient) {
    if (!patient) return '';
    const name = patient.legal_name || patient.name || '';
    if (!name) return '';
    // Match any token whose first character is a Unicode letter. Using the
    // \p{L} property ensures non-ASCII names (e.g. "Łukasz", "Δημήτρης")
    // contribute initials just like ASCII names do.
    const letterTokens = name.match(/[\p{L}][\p{L}\p{M}'-]*/gu) || [];
    return letterTokens
        .slice(0, 2)
        .map(token => token[0].toUpperCase())
        .join('');
}


/**
 * Strip large/redundant fields from a patient object before storing
 * as a template_patients embed on an Activity record.
 *
 * Removes: allergies, allergy_render, organization_uid, course_uid,
 * activity_uid, patient_description.
 *
 * @param {Object} patient - Full patient object
 * @returns {Object} Slimmed copy suitable for embedding
 */
export function patientEmbed(patient) {
    if (!patient) return patient;
    const {
        allergies,
        allergy_render,
        organization_uid,
        course_uid,
        activity_uid,
        patient_description,
        age_in_months,
        ...embed
    } = patient;
    return embed;
}
